










import Vue from 'vue'
import CustomMultiselect from '@/UI/Shared/CustomMultiselect.vue'
import { MultiselectOptions } from '@/UI/Shared/MultiselectOptions'
import { SweetAlertResult } from 'sweetalert2'

export default Vue.extend({
  name: 'UserTypeSelector',
  components: { CustomMultiselect },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      currentOption: 0,
      flagUserTypeChanged: false
    }
  },
  computed: {
    options (): MultiselectOptions[] {
      const options = [
        { id: 0, label: this.$t('subasta.documentations.user-selector.national-company').toString() },
        { id: 1, label: this.$t('subasta.documentations.user-selector.self-employed').toString() },
        { id: 2, label: this.$t('subasta.documentations.user-selector.unregistered-company').toString() },
        { id: 3, label: this.$t('subasta.documentations.user-selector.registered-company').toString() },
        { id: 4, label: this.$t('subasta.documentations.user-selector.foreign-company').toString() }
      ]

      return options.sort((a, b) => {
        return a.label.toString().localeCompare(b.label.toString())
      })
    }
  },
  watch: {
    value (newValue: number, oldValue: number) {
      if (newValue !== oldValue) {
        this.currentOption = newValue
      }
    }
  },
  created () {
    this.currentOption = this.value
  },
  methods: {
    onUserTypeChanged ($event: number) {
      if (this.flagUserTypeChanged) {
        if (this.currentOption > 0 || $event !== this.value) {
          this.$swal({
            title: this.$t('shared.atencion').toString(),
            text: this.$t('subasta.documentations.confirmDeleteFiles').toString(),
            icon: 'warning',
            showCancelButton: true,
            width: 400
          }).then((result: SweetAlertResult) => {
            if (result.value && result.value !== this.currentOption) {
              this.$emit('input', this.currentOption)
            }
          })
        }
      } else {
        if (this.currentOption > 0 || $event !== this.value) {
          this.$emit('input', this.currentOption)
          this.flagUserTypeChanged = true
        }
      }
    }
  }
})
